import React, { Component } from 'react';
import {Button} from 'reactstrap';

class SubmitSuccess extends Component {
  state = {  }
  render() { 
    return ( 
      <div className="text-center">
        <div>
          Great job! You successfully filled out a form. Want to see what your answers look like? 
          Head over to create a chart to find out!
        </div>
        <div className="row mt40" style={{justifyContent:'center'}}>
          <div className="col-md-4">
            <Button className="continueBtn w100 continueBtnTxt" onClick={this.props.nextBtnAction}>
              Create a Chart
            </Button>
          </div>
          <div className="col-md-4">
            <Button className="goBackBtn w100 goBackBtnTxt" onClick={this.props.nextBtnAction}>
              I'll do it later
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
 
export default SubmitSuccess;